import { render, staticRenderFns } from "./TabSearch.vue?vue&type=template&id=8d1b77e4&"
import script from "./TabSearch.vue?vue&type=script&lang=coffee&"
export * from "./TabSearch.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports